import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=385ffc22&scoped=true&"
import script from "./Rule.vue?vue&type=script&lang=js&"
export * from "./Rule.vue?vue&type=script&lang=js&"
import style0 from "./Rule.vue?vue&type=style&index=0&id=385ffc22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385ffc22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('385ffc22')) {
      api.createRecord('385ffc22', component.options)
    } else {
      api.reload('385ffc22', component.options)
    }
    module.hot.accept("./Rule.vue?vue&type=template&id=385ffc22&scoped=true&", function () {
      api.rerender('385ffc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/rules/Rule.vue"
export default component.exports